<template>
    <TitleBar
        :title="title"
        :subtitle="subtitle"
    />

</template>

<script>
import TitleBar from '@/components/TitleBar.vue';


export default {
    components: { TitleBar },
    props: {
        pageTitle: {
            type: String,
            default: null,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
    computed: {
        title() {
            if (this.pageTitle) {
                return this.pageTitle;
            }
            return this.$t('Page {page}', { page: this.currentPage + 1 });
        },
        subtitle() {
            return this.$t('Page {page} of {total}', {
                page: this.currentPage + 1,
                total: this.totalPages,
            });
        },
    },
};
</script>
